import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import saveFile from 'src/js/modules/common/helpers/save-file';
import errorCodes from '../../../constants/error-codes';

const saveDownloadFile = ({ file, customPath }) =>
  new Promise((resolve, reject) => {
    saveFile({
      file,
      customPath,
      dialogName: dialogTypes.UPLOAD_FILE_DIALOG,
      onFileUpload: (result) => {
        resolve({
          path: result.path,
          name: result.name,
        });
      },
      onUploadCancel: () => {
        reject(errorCodes.UPLOAD_FILE_CANCELED);
      },
      onSaveFileCancel: () => {
        reject(errorCodes.UPLOAD_FILE_CANCELED);
      },
    });
  });

export default saveDownloadFile;
